import pic1 from './doceree.png';
import pic2 from './network.png';
 
const ml = [
    {
        id: 1,
        image: pic1,
        title: "Doceree ML Hackthon",
        Desc: "The problem revolved around analyzing ad server logs, which contained critical information about user behavior, including browser details, IP addresses, geographic locations, search patterns, site URLs, and other relevant data. The main objective was to build a model that could accurately predict whether a user belonged to the HCP (Healthcare Professional) category and discern their specialization id/taxonomy, representing their specific area of expertise within the healthcare field.",
        stack: "Python",
        Github: "https://github.com/sanikaardekar/Doceree-ML-Hackathon",
        Link: "https://www.techgig.com/codegladiators/userprofile",
        Mentions: "Won 3rd Place in the hackathon conducted by TechGig Code Gladiators 2023"
        
    },
    {
        id: 2,
        image: pic2,
        title: "Network Anamoly Detection",
        Desc: "While a network administrator may be able to see and check the record of different IPs and PORTS, it may not be feasible for the administrator to go through all the logs and determine whether a behaviour is suspicious or not, Hence we propose a solution to classify whether an activity over a network is an anomaly or not.",
        stack: "Python",
        Github: "https://github.com/sanikaardekar/Network-Anamoly-Prediction-sem6",
        Link: "-",
        Mentions: "Project for Machine Learning Course "
    },
]
export default ml;